class PasswordController{
  constructor(
    $password,
    $stateParams,
    $state
  ) {
    'ngInject';
    this.$password = $password;
    this.$state    = $state;
    this.user = {
      email: null,
      token: $stateParams.token || null
    };
  }
  $onSubmit( type , form ){
    this.$password[type](this.user)
      .then(() => this.user.email = null)
      .finally(() => form.$submitted = false );
  }
}

export default PasswordController;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/password/password.controller.js
 **/